import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="h-16 w-16 bg-primary-500 rounded-xl flex items-center justify-center mb-6 mx-auto">
          <FontAwesomeIcon icon="robot" className="text-white text-2xl" />
        </div>
        <div className="flex items-center justify-center space-x-3 mb-4">
          <FontAwesomeIcon
            icon="spinner"
            className="animate-spin text-primary-500 text-lg"
          />
          <span className="text-slate-600 font-medium">{message}</span>
        </div>
        <p className="text-slate-500 text-sm">
          Please wait while we set things up...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
